export default "assets/images/icons/marker-ebd8c98b.svg";